import { isPreviewBuild } from 'components/common/previewEnv';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookie from 'services/Cookie';
import authUser from 'store/selectors/authUser';
import computeUserLastCompany from 'utils/computeUserLastCompany';
import redirect from 'utils/redirect';
import { buildWebUrl, isApexWebHostname } from 'utils/webOrigin';

const LoggedOutGate = ({ component: Component }) => {
  const user = useSelector(authUser);
  const company = computeUserLastCompany(user);

  useEffect(() => {
    // Preview has no per-company subdomains; never redirect to a company subdomain.
    if (isPreviewBuild()) {
      return;
    }
    const token = Cookie.get('token');
    if (!token?.hash) {
      return;
    }
    if (company?.subDomain) {
      redirect('/home/messages', company.subDomain);
      return;
    }
    // Shared auth cookie is valid on apex; HomeGate loads /me and redirects to default company.
    if (isApexWebHostname()) {
      window.location.replace(buildWebUrl('/home/messages'));
    }
  }, [company?.subDomain]);

  return <Component />;
};

export default LoggedOutGate;
